import LegacyFacebookIcon from '@/assets/LegacyFacebookIcon';
import LegacyInstagramIcon from '@/assets/LegacyInstagramIcon';
import LegacyLinkedinIcon from '@/assets/LegacyLinkedinIcon';
import LegacyTiktokIcon from '@/assets/LegacyTiktokIcon';
export const followUsLinks = [{
  icon: <LegacyFacebookIcon />,
  link: 'https://web.facebook.com/people/SkinSeoul/61559740437177/',
  name: 'Facebook'
}, {
  icon: <LegacyInstagramIcon />,
  link: 'https://www.instagram.com/skinseoul.official/',
  name: 'Instagram'
}, {
  icon: <LegacyTiktokIcon />,
  link: 'https://www.tiktok.com/@skinseoul.official',
  name: 'TikTok'
}, {
  icon: <LegacyLinkedinIcon />,
  link: 'https://www.linkedin.com/authwall?trk=bf&trkInfo=AQGM04AKIJs9_wAAAZBTB_2YfWR2_bzMd8jhFeJFt53ZX3L-xRXTE7waw3JJAt_RU1KFsv-CS7d1eUkw8lcFVDsRFsTRbO28qN9HgdOwGc67ef-R8-u6Qg-1Zys65Oyg-s15bVw=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fskinseoul',
  name: 'LinkedIn'
}];